module.exports = __webpack_public_path__ + "static/img/infoLeft.55a31e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoLeft.png
// module id = ouB8
// module chunks = 1